

const DataRenderer = {
  renderTradeAction: (tradeAction) => {
    if(!tradeAction)
        return;
    const trimmed = tradeAction.trim();
    if (trimmed === "B") return "Buy";
    if (trimmed === "S") return "Sell";
    if (trimmed === "SS") return "Sell Short";
    if (trimmed === "BO") return "Buy to Open";
    if (trimmed === "BC") return "Buy to Close";
    if (trimmed === "SO") return "Sell to Open";
    if (trimmed === "SC") return "Sell to Close";
    },

    renderSecurityType:(securityType)=>{
        if(securityType === "PrivateInvestment")
        return "Private Placement Investment";
        else return securityType;
    },

    RenderPoliticalContribType:(contribType)=>{
        return contribType === "Donation"?"Fundraising/Solicitation/Volunteer ":"Political Contribution";
    },

    numberToFixed: (num, fixed) => {
        if (num === undefined || num === null || num === "" || isNaN(num)) {
            return "";                
        }
        num = parseFloat(num);
        return num.toFixed(fixed);
    },

    dateStrStripDate: (dateStr) => {
        if (dateStr === undefined || dateStr === null || dateStr === "") {
            return "";
        }
        var i = dateStr.indexOf(" ");
        if (i > 0) {
            return dateStr.substring(0, i);
        }
        return dateStr;
    }


};




export default DataRenderer;
